import { APP_BASE_HREF } from '@angular/common';
import { Routes } from '@angular/router';


import { LeadComponent } from '../lead-component/lead-component.component';
import { LoginComponent } from '../login/login.component';
import { AuthGuard } from '../service/guards/auth-guard.guard';

//order of routes matter
export const routes: Routes = [
  { path: "", component: LeadComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: "**", component: LeadComponent, canActivate: [AuthGuard] }
];
